import { Injectable, TemplateRef } from '@angular/core';
import { SlideBaseComponent } from '../shared/components/slide-base-component/slide-base-component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CarritoService } from './carrito-service';
export const DRAWER_WIDTHS = {
  XSMALL: '30VW',
  SMALL: '35VW',
  MEDIUM: '40VW',
  LARGE: '45VW',
  XLARGE: '50VW',
  XXLARGE: '60VW',
  XXLARGEMOVIL: '80VW',
} as const;

export interface DrawerButton {
  label: string;
  action: () => void;
  variant?: 'primary' | 'secondary' | 'danger';
  disabled?: boolean;
}

export interface DrawerConfig {
  title?: string;
  subtitle?: string;
  content: TemplateRef<unknown>;
  contentContext?: Record<string, unknown>;
  buttons?: DrawerButton[];
  width?: 'small' | 'medium' | 'large' | 'xlarge' | string;
  resizable?: boolean;
  onClose?: () => void;
  onReady?: () => void;
}

@Injectable({ providedIn: 'root' })
export class DrawerService {
  constructor(private dialog: MatDialog, private carritoService: CarritoService) { }

  open(config: DrawerConfig): MatDialogRef<SlideBaseComponent> {
    let widthValue: string;
    switch (config.width) {
      case 'small':
        widthValue = DRAWER_WIDTHS.SMALL;
        break;
      case 'medium':
        widthValue = DRAWER_WIDTHS.MEDIUM;
        break;
      case 'large':
        widthValue = DRAWER_WIDTHS.LARGE;
        break;
      case 'xlarge':
        widthValue = DRAWER_WIDTHS.XLARGE;
        break;
      default:
        widthValue = config.width || DRAWER_WIDTHS.MEDIUM;
    }
    return this.dialog.open(SlideBaseComponent, {
      position: { right: '0' },
      height: '100vh',
      width: widthValue,
      maxWidth: '100vw',
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true,
      autoFocus: false,
      data: config,
    });
  }

  close(): void {
    const dialogs = this.dialog.openDialogs;
    console.log(this.carritoService.isOpen())
    if (this.carritoService.isOpen()) {
      this.carritoService.reset();
    }
    if (dialogs.length) {
      dialogs[dialogs.length - 1].close();
    }

  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
